import api from '@/api'
export default {
  // 获取会员协会列表
  getOrganList (params) {
    return api({
      url: '/organ/organList',
      method: 'GET',
      params
    })
  },
  addOrgan (data) {
    return api({
      url: '/organ/addOrgan',
      method: 'POST',
      data
    })
  },
  updateOrg (data) {
    return api({
      url: '/organ/editOrgan',
      method: 'PUT',
      data
    })
  },
  getOrgInfo (uuid) {
    return api({
      url: `/organ/organInfo/${uuid}`,
      method: 'GET'
    })
  },
  getOrganSettingData (params) {
    return api({
      url: '/organ/organSettingData',
      method: 'GET',
      params
    })
  },
  setOrganSettingData (data) {
    return api({
      url: '/organ/organSettingSave',
      method: 'POST',
      data
    })
  }

}
